import { render, staticRenderFns } from "./set_boss.vue?vue&type=template&id=2720b8a8&scoped=true&"
import script from "./set_boss.vue?vue&type=script&lang=js&"
export * from "./set_boss.vue?vue&type=script&lang=js&"
import style0 from "./set_boss.vue?vue&type=style&index=0&id=2720b8a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2720b8a8",
  null
  
)

export default component.exports